import { Text, type TextProps } from "@mantine/core";
import clsx from "clsx";
import type { ReactNode } from "react";

interface ISSWhiteTextProps {
  children: ReactNode;
}

const SSWhiteText: React.FC<ISSWhiteTextProps & TextProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <Text
      inherit
      span
      className={clsx("text-primary-white", className)}
      variant="text"
      {...rest}
    >
      {children}
    </Text>
  );
};

export default SSWhiteText;
